import { render, staticRenderFns } from "./ProgressReportFormOld.vue?vue&type=template&id=12323017&"
import script from "./ProgressReportFormOld.vue?vue&type=script&lang=js&"
export * from "./ProgressReportFormOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports